import { z } from 'zod';

export const emailSchema = z.object({
  email: z.string().email('Please enter a valid email address'),
});

export const otpSchema = z.object({
  otp: z
    .string()
    .length(6, 'OTP must be 6 digits')
    .regex(/^\d{6}$/, 'OTP must contain only digits'),
});

export const passwordLoginSchema = z.object({
  email: z.string().email(),
  password: z.string().min(6, 'Password must be at least 6 characters'),
});

export const registerCompanyStepSchema = z.object({
  companyName: z
    .string()
    .min(2, 'Company name must be at least 2 characters')
    .max(120),
});

export const registerAccountStepSchema = z
  .object({
    firstname: z.string().min(1, 'Required').max(60),
    lastname: z.string().min(1, 'Required').max(60),
    email: z.string().email('Please enter a valid email address'),
    password: z
      .string()
      .min(8, 'Password must be at least 8 characters')
      .max(128),
    confirmPassword: z.string(),
  })
  .refine((d) => d.password === d.confirmPassword, {
    path: ['confirmPassword'],
    message: 'Passwords do not match',
  });

export const registerOtpStepSchema = otpSchema;

export type EmailInput = z.infer<typeof emailSchema>;
export type OtpInput = z.infer<typeof otpSchema>;
export type PasswordLoginInput = z.infer<typeof passwordLoginSchema>;
export type RegisterCompanyInput = z.infer<typeof registerCompanyStepSchema>;
export type RegisterAccountInput = z.infer<typeof registerAccountStepSchema>;
export type RegisterOtpInput = z.infer<typeof registerOtpStepSchema>;
